import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const PersonList = React.lazy(() => import('components/Person/List/List'));

function ScreensPersonList() {
  return (
    <BaseLayout>
      <DocumentTitle>People Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <PersonList />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensPersonList;
